import { render, staticRenderFns } from "./Restaurante.vue?vue&type=template&id=03951660&scoped=true&"
import script from "./Restaurante.vue?vue&type=script&lang=js&"
export * from "./Restaurante.vue?vue&type=script&lang=js&"
import style0 from "./Restaurante.vue?vue&type=style&index=0&id=03951660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03951660",
  null
  
)

export default component.exports